import RestService from "./rest.service";

class Proxy {
  proxyHistory() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/security/proxy/history`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  proxyEmployee(word = '') {
    return new Promise((fnResolve, fnReject) => {
      let url = `app/kpi/security/proxy/users`
      if (word) url += '?word=' + word;
      RestService.gets(url).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  proxyEmployeeSearch(word = '') {
    return new Promise((fnResolve, fnReject) => {
      let url = `app/kpi/security/proxy/users/search`
      RestService.posts(url, { word }).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  loginByProxy(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/security/proxy/login`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  logoutByProxy(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/security/proxy/logout`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new Proxy();
